<template>
  <div>
    <a-card class="card">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchForm"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>

    <a-card>
      <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="{ x: 800 }"
        size="middle"
        @handlePagination="handleClickPage"
      ></TableView>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import mixin from './mixin'
import { getTableData } from './api'

export default {
  mixins: [mixin],
  data() {
    return {
      searchCardLoading: true,
      tableLoading: true,
    }
  },
  components: {
    SearchView,
    TableView,
  },
  mounted() {
    this._getTableData()
  },
  methods: {
    // 获取表格数据
    _getTableData() {
      this.tableLoading = true
      const { current, pageSize } = this.pageData

      const formData = {
        ...this.searchForm,
        size: pageSize,
        current,
        companyCode: this.$store.getters['app/company'].code,
      }
      if (formData.date.length) {
        formData.startTime = formData.date[0]
        formData.endTime = formData.date[1]
      }
      delete formData.date
      delete formData.pageSize

      getTableData(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      })
    },
  },
}
</script>
